var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ellipsis"},[_c('div',{staticClass:"ellipsis__content",style:({ paddingRight: _vm.paddingRight || 0 }),attrs:{"id":_vm.id}},[_vm._t("default")],2),(_vm.tooltip?.length > 1)?_c('b-tooltip',{attrs:{"target":_vm.id,"triggers":"hover","placement":_vm.placement || 'bottom'}},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }